import { Component, Input, OnInit } from '@angular/core';
import { BrandService } from '../../services/brand.service';

@Component({
  selector: 'app-letterhead-a4',
  templateUrl: './letterhead-a4.component.html',
  styleUrls: ['./letterhead-a4.component.css'],
})
export class LetterheadA4Component implements OnInit {
  // Brand type - can be 'healthpluspeople' or 'agrilabour'
  @Input() brandType: string = '';
  
  // Use legacy view for Agrilabour (with custom header/footer)
  @Input() useLegacyView: boolean = false;
  
  // Default assets can be overridden by inputs
  @Input() logoSrc: string = '';

  // Optional footer text lines (override to customize)
  @Input() footerLines: string[] = [];

  // Optional footer icons (right aligned)
  @Input() footerIcons: string[] = [];
  
  // Brand-specific alt text
  brandAltText: string = '';

  constructor(private brandService: BrandService) {}

  ngOnInit() {
    // Determine brand type if not explicitly set
    if (!this.brandType) {
      this.brandType = this.brandService.isHealthPlusPeople() ? 'healthpluspeople' : 'agrilabour';
    }
    
    // For Agrilabour, default to legacy view unless explicitly set otherwise
    if (this.brandType === 'agrilabour' && this.useLegacyView === false) {
      this.useLegacyView = true;
    }
    
    // Set brand-specific defaults if not overridden
    this.setupBrandDefaults();
  }

  private setupBrandDefaults() {
    if (this.brandType === 'healthpluspeople') {
      // Health+People branding
      if (!this.logoSrc) {
        this.logoSrc = 'assets/img/health_People.png';
      }
      
      if (this.footerLines.length === 0) {
        // We're handling the footer lines directly in the template for Health+People
        this.footerLines = [];
      }
      
      if (this.footerIcons.length === 0) {
        // Add the footer icons for Health+People
        this.footerIcons = [
          'assets/img/rcsa-icon.png',
          'assets/img/staffsure-icon.png',
          'assets/img/hire-icon.png'
        ];
      }
      
      this.brandAltText = 'Health+People';
    } else {
      // Agrilabour branding
      if (!this.logoSrc) {
        this.logoSrc = 'assets/img/agrilabour-logo-01.png';
      }
      
      if (this.footerLines.length === 0) {
        this.footerLines = [
          'G01N 527 Gregory Terrace, Fortitude Valley QLD 4006',
          'T: 1300 247 823  |  E: info@agrilabour.com.au',
          'ABN 23 142 526 216  |  ACN 142 526 216',
          'AGRILABOUR.COM.AU',
        ];
      }
      
      if (this.footerIcons.length === 0) {
        // Using existing icons from assets/img since we don't have specific branding folder
        this.footerIcons = [];
      }
      
      this.brandAltText = 'Agri Labour Australia';
    }
  }
}